/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MilestoneResponse } from './MilestoneResponse';
import {
    MilestoneResponseFromJSON,
    MilestoneResponseFromJSONTyped,
    MilestoneResponseToJSON,
    MilestoneResponseToJSONTyped,
} from './MilestoneResponse';
import type { RewardConfigResponse } from './RewardConfigResponse';
import {
    RewardConfigResponseFromJSON,
    RewardConfigResponseFromJSONTyped,
    RewardConfigResponseToJSON,
    RewardConfigResponseToJSONTyped,
} from './RewardConfigResponse';
import type { GuildQuestMode } from './GuildQuestMode';
import {
    GuildQuestModeFromJSON,
    GuildQuestModeFromJSONTyped,
    GuildQuestModeToJSON,
    GuildQuestModeToJSONTyped,
} from './GuildQuestMode';
import type { GuildQuestUserStat } from './GuildQuestUserStat';
import {
    GuildQuestUserStatFromJSON,
    GuildQuestUserStatFromJSONTyped,
    GuildQuestUserStatToJSON,
    GuildQuestUserStatToJSONTyped,
} from './GuildQuestUserStat';
import type { OWGameEventType } from './OWGameEventType';
import {
    OWGameEventTypeFromJSON,
    OWGameEventTypeFromJSONTyped,
    OWGameEventTypeToJSON,
    OWGameEventTypeToJSONTyped,
} from './OWGameEventType';

/**
 * Collection contains the quests that can be completed.
 * @export
 * @interface GuildQuest
 */
export interface GuildQuest {
    /**
     * 
     * @type {string}
     * @memberof GuildQuest
     */
    guild?: string;
    /**
     * The game that the quest is for if quest is event based. Required for event based quests.
     * @type {string}
     * @memberof GuildQuest
     */
    game?: string;
    /**
     * The title of the quest.
     * @type {string}
     * @memberof GuildQuest
     */
    name: string;
    /**
     * The description of the quest.
     * @type {string}
     * @memberof GuildQuest
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GuildQuest
     */
    isGuildQualifier?: boolean;
    /**
     * 
     * @type {OWGameEventType}
     * @memberof GuildQuest
     */
    eventType: OWGameEventType;
    /**
     * The target amount of progress (in minutes) to reach to claim the reward. Should be in days if mode is DIFF_DAYS.
     * @type {number}
     * @memberof GuildQuest
     */
    target: number;
    /**
     * 
     * @type {Array<MilestoneResponse>}
     * @memberof GuildQuest
     */
    milestones?: Array<MilestoneResponse>;
    /**
     * 
     * @type {Array<RewardConfigResponse>}
     * @memberof GuildQuest
     */
    rewardConfigs?: Array<RewardConfigResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof GuildQuest
     */
    isActive?: boolean;
    /**
     * 
     * @type {GuildQuestMode}
     * @memberof GuildQuest
     */
    mode?: GuildQuestMode;
    /**
     * The target amount of progress (in minutes) (Only relevant for DIFF_DAYS mode)
     * @type {number}
     * @memberof GuildQuest
     */
    dailyTarget?: number;
    /**
     * 
     * @type {GuildQuestUserStat}
     * @memberof GuildQuest
     */
    userStat?: GuildQuestUserStat;
    /**
     * 
     * @type {string}
     * @memberof GuildQuest
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GuildQuest
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof GuildQuest
     */
    updatedAt: number;
}



/**
 * Check if a given object implements the GuildQuest interface.
 */
export function instanceOfGuildQuest(value: object): value is GuildQuest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('eventType' in value) || value['eventType'] === undefined) return false;
    if (!('target' in value) || value['target'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function GuildQuestFromJSON(json: any): GuildQuest {
    return GuildQuestFromJSONTyped(json, false);
}

export function GuildQuestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GuildQuest {
    if (json == null) {
        return json;
    }
    return {
        
        'guild': json['guild'] == null ? undefined : json['guild'],
        'game': json['game'] == null ? undefined : json['game'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'isGuildQualifier': json['isGuildQualifier'] == null ? undefined : json['isGuildQualifier'],
        'eventType': OWGameEventTypeFromJSON(json['eventType']),
        'target': json['target'],
        'milestones': json['milestones'] == null ? undefined : ((json['milestones'] as Array<any>).map(MilestoneResponseFromJSON)),
        'rewardConfigs': json['rewardConfigs'] == null ? undefined : ((json['rewardConfigs'] as Array<any>).map(RewardConfigResponseFromJSON)),
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'mode': json['mode'] == null ? undefined : GuildQuestModeFromJSON(json['mode']),
        'dailyTarget': json['dailyTarget'] == null ? undefined : json['dailyTarget'],
        'userStat': json['userStat'] == null ? undefined : GuildQuestUserStatFromJSON(json['userStat']),
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function GuildQuestToJSON(json: any): GuildQuest {
    return GuildQuestToJSONTyped(json, false);
}

export function GuildQuestToJSONTyped(value?: GuildQuest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'guild': value['guild'],
        'game': value['game'],
        'name': value['name'],
        'description': value['description'],
        'isGuildQualifier': value['isGuildQualifier'],
        'eventType': OWGameEventTypeToJSON(value['eventType']),
        'target': value['target'],
        'milestones': value['milestones'] == null ? undefined : ((value['milestones'] as Array<any>).map(MilestoneResponseToJSON)),
        'rewardConfigs': value['rewardConfigs'] == null ? undefined : ((value['rewardConfigs'] as Array<any>).map(RewardConfigResponseToJSON)),
        'isActive': value['isActive'],
        'mode': GuildQuestModeToJSON(value['mode']),
        'dailyTarget': value['dailyTarget'],
        'userStat': GuildQuestUserStatToJSON(value['userStat']),
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

